



















































































































































































import {
  FormSubmissionChecklistStateInfo,
  FormSubmissionChecklistStateEnum,
  IWorkflowFormSubmission,
  IWorkflowFormSubmissionChecklist,
  IFormSubmissionChecklistStateInfo
} from '@/models';
import { ErrorManager } from '@/models/error';

import { diffDeep } from '@/utils/helpers';
import snackbar from '@/mixins/snackbar';
import mixins from '@/utils/mixins';

import { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import ErrorAlert from '../common/ErrorAlert.vue';
import moment from 'moment';
import { IUpdateSubmissionChecklistAssigneePayload } from '@/services';
import WorkflowFormAssigneePicker from './WorkflowFormAssigneePicker.vue';

export enum ExpansionEnum {
  Open,
  Close
}

export default mixins(snackbar).extend({
  components: { ErrorAlert, WorkflowFormAssigneePicker },

  props: {
    title: String,
    checklists: Array as PropType<IWorkflowFormSubmissionChecklist[]>,
    submission: Object as PropType<IWorkflowFormSubmission>
  },

  data() {
    return {
      errorMessage: '',
      detailErrorMessage: '',

      isEditingAssignee: false,
      openDropDown: ExpansionEnum.Close,

      loading: false
    };
  },

  computed: {
    ...mapGetters({
      getWorkflowFormSubmissionChecklistById:
        'workflowForm/getWorkflowFormSubmissionChecklistById'
    }),

    isChecklistCompleted(): boolean {
      return this.checklists.every(
        checklist =>
          checklist.state != FormSubmissionChecklistStateEnum.InProgress
      );
    },

    checklistProgressInfo(): { color: string; icon: string } {
      let statusColor = { color: 'grey', icon: 'mdi-card-text-outline' };

      if (this.isChecklistCompleted) {
        statusColor = { color: 'success', icon: 'mdi-check-bold' };
      } else if (
        this.checklists.some(
          checklist =>
            checklist.state != FormSubmissionChecklistStateEnum.InProgress
        )
      ) {
        statusColor = { color: 'submitted', icon: 'mdi-dots-horizontal' };
      }
      return statusColor;
    },

    getCompletedAtDate(): string {
      let date = this.checklists[0].completed_at;

      //gets the latest date
      date = this.checklists.reduce((a, b) => {
        return new Date(a.completed_at as string) >
          new Date(b.completed_at as string)
          ? a
          : b;
      }).completed_at as string;

      return moment(date).format('MMMM D, YYYY [at] h:mma');
    },

    checklistStateList(): IFormSubmissionChecklistStateInfo[] {
      return FormSubmissionChecklistStateInfo.getFormSubmissionChecklistStateInfoList();
    }
  },

  methods: {
    moment,

    ...mapActions({
      markCompleteWorkflowFormSubmissionChecklist:
        'workflowForm/markCompleteWorkflowFormSubmissionChecklist',
      updateWorkflowFormSubmissionChecklistAssignee:
        'workflowForm/updateWorkflowFormSubmissionChecklistAssignee'
    }),

    //filter for unselected state
    loadChecklistStateList(state: IFormSubmissionChecklistStateInfo) {
      return this.checklistStateList.filter(
        checklistate => checklistate.value != state.value
      );
    },

    clearAllErrors() {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    toggleEditAssignee() {
      this.openDropDown = ExpansionEnum.Open;
      this.isEditingAssignee = !this.isEditingAssignee;
    },

    async updateAssignee(checklists: IWorkflowFormSubmissionChecklist[]) {
      for (const checklist of checklists) {
        const payload = {
          id: checklist.id,
          form_submission: checklist.form_submission,
          assignee: checklist.assignee
        } as IUpdateSubmissionChecklistAssigneePayload;

        await this.updateWorkflowFormSubmissionChecklistAssignee(payload);
      }
    },

    async saveAssignees() {
      //filter checklist that have been edited
      const updateChecklists = this.checklists.filter(
        checklist => typeof checklist.assignee == 'number'
      );

      this.loading = true;

      if (updateChecklists.length > 0) {
        this.updateAssignee(updateChecklists)
          .then(() => {
            this.createSnack({
              color: 'success darken-1',
              type: 'success',
              right: true,
              useBtn: false,
              msg: `Assignee updated successfully`,
              btnText: 'Ok',
              timeout: 6000
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.data.detail) {
                this.detailErrorMessage = error.response.data.detail;
              }
            }
            this.errorMessage = ErrorManager.extractApiError(error);
          });
      }

      this.toggleEditAssignee();
      this.loading = false;
    },

    updateFormSubmissionChecklist(
      checklist: IWorkflowFormSubmissionChecklist,
      state: FormSubmissionChecklistStateEnum
    ) {
      this.loading = true;

      const submissionChecklist = { ...checklist, state };

      const payload = diffDeep(
        submissionChecklist,
        this.getWorkflowFormSubmissionChecklistById(checklist.id),
        true
      );

      payload.form_submission = submissionChecklist.form_submission;

      this.markCompleteWorkflowFormSubmissionChecklist(payload)
        .catch(error => {
          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
});
